/**
 * Directive for setting up a print button.
 *
 * Parameters:
 * @param label              label for the button
 * @param action             function called after printing is done, use "true" for noop-action. otherwise route will be reloaded
 * @param entryPointParam    sets the extended entry point url
 * @param prePrintAction     the action to perform before the print
 * @param printToken         the token to get the parameters from
 * @param printTokenFunction the function to get the print token from
 */
angular.module('impactx.printbutton').directive('ixPrintButton', function() {
    return {
        scope: {
            label: "=",
            action: "=",
            entryPointParam: "@",
            prePrintAction: "=",
            printToken: "@",
            printTokenFunction: "=",
        },
        restrict: 'E',
        templateUrl: 'shared/printbutton/templates/printbutton.tmpl.html',
        transclude: true,
        controller: 'PrintButtonCtrl',
        controllerAs: 'ctrl'
    };
});